<template>
  <div>
    <!-- 설명 -->
    <p class="mb-5">
      ※ 관리감독자가 담당종사자를 직접 작성하는 페이지입니다. <br />
      ※ 사업장별 최초 작성 후 변동사항이 생겼을시 이전에 작성했던 문서를 열어 수정하여 저장합니다.
    </p>

    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :types="fieldTypes" :typeslabel="fieldTypesLabel" />

    <!-- 사무직 종사자 현황 -->
    <table-custom :board="board" :is-print="isPrint" title="사무직 종사자 현황" :tableData="tableData1" v-model="form.worker1">
      <template #customTr>
        <tr style="background: #f9f9f9 !important">
          <td :colspan="board.readonly? 3:4"></td>
          <td class="text-center">소계</td>
          <td style="padding: 10px 15px">
            <comma-input readonly placeholder="자동입력" v-model="form.workerNum1" class="w-full flex-1" />
          </td>
          <td></td>
        </tr>
      </template>
    </table-custom>
    <!-- 직영사업장 종사자 현황 -->
    <table-custom :board="board" :is-print="isPrint" title="직영사업장 종사자 현황" :tableData="tableData2" v-model="form.worker2">
      <template #customTr>
        <tr style="background: #f9f9f9 !important">
          <td :colspan="board.readonly? 3:4"></td>
          <td class="text-center">소계</td>
          <td style="padding: 10px 15px">
            <comma-input readonly placeholder="자동입력" v-model="form.workerNum2" class="w-full flex-1" />
          </td>
          <td></td>
        </tr>
      </template>
    </table-custom>
    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    projectId() {
      return Number(this.$route.params.proj_id);
    },

    fieldTypes() {
      return ["department", "com_name", "rank", "writer_name", "updated_at"];
    },
    fieldTypesLabel() {
      return {
        field_name: "사업장명",
        department: "소속명",
        com_name: "부서명",
        rank: "직책",
        writer_name: "작성자",
        date: "최종수정일",
      };
    },
    tableData1() {
      return [
        { id: "input1", title: "No.", type: "no", vertical: "middle", width: "80px" },
        { id: "input6", title: "부서명", type: "text", readonly: true, vertical: "middle", value: this.form.stdInfo.section },
        {
          id: "input5",
          title: "구분",
          type: "select",
          placeholder: "선택",
          selectData: [
            "사무직",
            "현업 - 청소 등 유지관리",
            "현업 - 도로의 유지·보수 종사자",
            "현업 - 환경미화종사자",
            "현업 - 폐기물 수거처리",
            "현업 - 공원·녹지 유지관리",
            "현업 - 산림조사·보호",
            "현업 - 조리시설",
            "현업",
            "노동자",
            "청원경찰",
            "기타",
          ],
        },
        {
          id: "input2",
          title: "직종",
          type: "select",
          placeholder: "선택",
          selectData: ["공무원", "공무직", " 임기제", "기간제", "기능직", "근로자", "공공근로", "노인 일자리", "장애인 일자리", "지역공동체", "자활", "기타"],
        },
        {
          id: "input3",
          title: "인원수",
          type: "number",
          placeholder: "숫자입력",
        },
        { id: "input4", title: "비고", type: "text", placeholder: "입력" },
      ];
    },
    tableData2() {
      return [
        { id: "input1", title: "No.", type: "no", width: "80px", vertical: "middle" },
        { id: "input6", title: "사업장명", type: "field", vertical: "middle" },
        {
          id: "input5",
          title: "구분",
          type: "select",
          placeholder: "선택",
          selectData: [
            "사무직",
            "현업 - 청소 등 유지관리",
            "현업 - 도로의 유지·보수 종사자",
            "현업 - 환경미화종사자",
            "현업 - 폐기물 수거처리",
            "현업 - 공원·녹지 유지관리",
            "현업 - 산림조사·보호",
            "현업 - 조리시설",
            "현업",
            "노동자",
            "청원경찰",
            "기타",
          ],
        },
        {
          id: "input2",
          title: "직종",
          type: "select",
          placeholder: "선택",
          selectData: ["공무원", "공무직", " 임기제", "기간제", "기능직", "근로자", "공공근로", "노인 일자리", "장애인 일자리", "지역공동체", "자활", "기타"],
        },
        {
          id: "input3",
          title: "인원수",
          type: "number",
          placeholder: "숫자입력",
        },
        { id: "input4", title: "비고", type: "text", placeholder: "입력" },
      ];
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;

        // 상세내용 No. 추가
        if (!!value.worker1 && 0 < value.worker1.length) {
          value.workerNum1 = value.worker1.reduce((prev, _w) => {
            const n = Number(_w.input3 || 0);
            return n + prev;
          }, 0);
        } else value.workerNum1 = null;

        if (!!value.worker2 && 0 < value.worker2.length) {
          value.workerNum2 = value.worker2.reduce((prev, _w) => {
            const n = Number(_w.input3 || 0);
            return n + prev;
          }, 0);
        } else value.workerNum2 = null;

        value.workerNum = value.workerNum1 + value.workerNum2;

        // 그래프처리
        value.summary = {
          종사자현황_부서: [],
          종사자현황_사업장: [],
          종사자현황_구분: [],
          종사자현황_직종: [],
          종사자현황_부서_구분: [],
          종사자현황_부서_구분_직종: [],
          종사자현황_사업장_구분: [],
          종사자현황_사업장_구분_직종: [],
          종사자현황_부서_사업장_구분_직종: [],
        };

        if (this.form.stdInfo) {
          const totalObj = {
            '부서': {},
            '사업장': {},
            '구분': {},
            '직종': {},
            '부서_구분': {},
            '부서_구분_직종': {},
            '사업장_구분': {},
            '사업장_구분_직종': {},
            '부서_사업장_구분_직종': {},
          }
          for (const worker of value.worker1) {
            const 부서 = worker.input6
            const 구분 = worker.input5
            const 직종 = worker.input2
            const 인원수 = typeof worker.input3 === 'string' ? Number(worker.input3) : 0

            // 구분 또는 직종을 선택했을 경우에만 카운팅
            if (!totalObj['부서'][부서]) totalObj['부서'][부서] = 0;
            if (!totalObj['구분'][구분]) totalObj['구분'][구분] = 0;
            if (!totalObj['직종'][직종]) totalObj['직종'][직종] = 0;
            if (!totalObj['부서_구분'][`${부서}_${구분}`]) totalObj['부서_구분'][`${부서}_${구분}`] = 0;
            if (!totalObj['부서_구분_직종'][`${부서}_${구분}_${직종}`]) totalObj['부서_구분_직종'][`${부서}_${구분}_${직종}`] = 0;

            totalObj['부서'][부서] += 인원수;
            totalObj['구분'][구분] += 인원수;
            totalObj['직종'][직종] += 인원수;
            totalObj['부서_구분'][`${부서}_${구분}`] += 인원수;
            totalObj['부서_구분_직종'][`${부서}_${구분}_${직종}`] += 인원수;
          }

          for (const worker of value.worker2) {
            const 사업장 = worker.input6_fieldName
            const 구분 = worker.input5
            const 직종 = worker.input2
            const 인원수 = typeof worker.input3 === 'string' ? Number(worker.input3) : 0

            // 구분 또는 직종을 선택했을 경우에만 카운팅
            if (!totalObj['사업장'][사업장]) totalObj['사업장'][사업장] = 0;
            if (!totalObj['구분'][구분]) totalObj['구분'][구분] = 0;
            if (!totalObj['직종'][직종]) totalObj['직종'][직종] = 0;
            if (!totalObj['사업장_구분'][`${사업장}_${구분}`]) totalObj['사업장_구분'][`${사업장}_${구분}`] = 0;
            if (!totalObj['사업장_구분_직종'][`${사업장}_${구분}_${직종}`]) totalObj['사업장_구분_직종'][`${사업장}_${구분}_${직종}`] = 0;

            totalObj['사업장'][사업장] += 인원수;
            totalObj['구분'][구분] += 인원수;
            totalObj['직종'][직종] += 인원수;
            totalObj['사업장_구분'][`${사업장}_${구분}`] += 인원수;
            totalObj['사업장_구분_직종'][`${사업장}_${구분}_${직종}`] += 인원수;
          }

          const _keys_부서 = Object.keys(totalObj['부서'])
          for (const 부서 of _keys_부서) {
            value.summary["종사자현황_부서"].push({ [부서]: totalObj['부서'][부서] });
          }
          const _keys_사업장 = Object.keys(totalObj['사업장'])
          for (const 사업장 of _keys_사업장) {
            value.summary["종사자현황_사업장"].push({ [사업장]: totalObj['사업장'][사업장] });
          }
          const _keys_구분 = Object.keys(totalObj['구분'])
          for (const 구분 of _keys_구분) {
            value.summary["종사자현황_구분"].push({ [구분]: totalObj['구분'][구분] });
          }
          const _keys_직종 = Object.keys(totalObj['직종'])
          for (const 직종 of _keys_직종) {
            value.summary["종사자현황_직종"].push({ [직종]: totalObj['직종'][직종] });
          }
          const _keys_부서_구분 = Object.keys(totalObj['부서_구분'])
          for (const 부서_구분 of _keys_부서_구분) {
            value.summary["종사자현황_부서_구분"].push({ [부서_구분]: totalObj['부서_구분'][부서_구분] });
          }
          const _keys_부서_구분_직종 = Object.keys(totalObj['부서_구분_직종'])
          for (const 부서_구분_직종 of _keys_부서_구분_직종) {
            value.summary["종사자현황_부서_구분_직종"].push({ [부서_구분_직종]: totalObj['부서_구분_직종'][부서_구분_직종] });
          }
          const _keys_사업장_구분 = Object.keys(totalObj['사업장_구분'])
          for (const 사업장_구분 of _keys_사업장_구분) {
            value.summary["종사자현황_사업장_구분"].push({ [사업장_구분]: totalObj['사업장_구분'][사업장_구분] });
          }
          const _keys_사업장_구분_직종 = Object.keys(totalObj['사업장_구분_직종'])
          for (const 사업장_구분_직종 of _keys_사업장_구분_직종) {
            value.summary["종사자현황_사업장_구분_직종"].push({ [사업장_구분_직종]: totalObj['사업장_구분_직종'][사업장_구분_직종] });
          }
        }

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        worker1: [],
        worker2: [],
        workerNum1: null,
        workerNum2: null,
        workerNum: 0,
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
